<template>
    <div style="margin: 0px; padding: 0px;">
            <span style="width: 200px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
                充值成功<br/><br/>
                <el-button type="primary" @click="close()"><span style="font-size:16px;">关闭页面</span></el-button>
            </span>
    </div>
</template>
<script>
export default {
    methods:{
        close(){
            window.close();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/paysuccess.vue